import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { SUPER_ADMIN_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/super-admin/parking")({
  head: () => ({
    meta: [
      { title: "Parking control · Landoo Super Admin" },
      {
        name: "description",
        content: "Global parking category settings, providers and moderation rules.",
      },
    ],
  }),
  component: () => (
    <DashboardShell title="Parking control" role="Super Admin" items={SUPER_ADMIN_NAV}>
      <div className="grid gap-3 md:grid-cols-2">
        <PlaceholderCard
          title="Parking category settings"
          description="Enable or disable the Parking category platform-wide."
        />
        <PlaceholderCard
          title="Parking providers"
          description="All parking operators and their entitlements."
        />
        <PlaceholderCard
          title="Parking pricing rules"
          description="Platform commission and pricing guardrails for parking."
        />
        <PlaceholderCard
          title="Parking booking rules"
          description="Configure future parking booking policy and cancellation windows."
        />
      </div>
    </DashboardShell>
  ),
});
